module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-container",
    class: _vm.notification_class,
    on: {
      "click": _vm.make_inactive
    }
  }, [_c('popup-notification', {
    attrs: {
      "type": "correct",
      "title": _vm.computedTitle
    }
  }, [_vm._v(_vm._s(_vm.captionState.caption))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9669d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/notification.vue
// module id = 614
// module chunks = 1